export default {
  "and": "y",
  "Back": "Atrás",
  "Click to Expand": "Clic para Ampliar",
  "Click to Hide": "Clic para Ocultar",
  "Click to Highlight": "Clic para Resaltar",
  "Click to Reset": "Clic para Restablecer",
  "Download": "Descargar",
  "Loading Visualization": "Cargando Visualización",
  "No Data Available": "Datos No Disponibles",
  "Powered by D3plus": "Funciona con D3plus",
  "Share": "Porcentaje",
  "Shift+Click to Hide": "Mayús+Clic para Ocultar",
  "Total": "Total",
  "Values": "Valores"
};


//////////////////
// WEBPACK FOOTER
// ./~/d3plus-common/es/src/locales/es-ES.js
// module id = qrqS
// module chunks = 0